const Routes = {
  LOGOUT: '/logout',
  ROOT: '/',
  ACCESS_DENIED: '/access-denied',
  MAINTENANCE: '/maintenance',
  SESSION_EXPIRED: '/session-expired',
  CHANGE_CLIENT: '/change-client/:clientId',
  USER_PROFILE: {
    state: {
      modal: 'userProfile',
    },
  },

  dashboard: {
    MAIN: '/dashboard',
    CONNECTION_RUN_STATUS: '/dashboard/connection-run-status',
    CONNECTION_MONITOR: '/dashboard/connection-monitor',
    PROVISION_QUALITY_OVERVIEW: '/dashboard/provision-quality-overview',
    PROVISION_QUALITY_SINGLE: '/dashboard/provision-quality-single',
    PROVISION_QUALITY_SINGLE_WITH_PARAMS: '/dashboard/provision-quality-single/:resourceType/:resource',
  },

  scenarios: {
    MAIN: '/scenarios',
    MEMBERS_LIST: '/scenarios/:scenarioId/members-list',
    ADD_MEMBERS: '/scenarios/:scenarioId/add-members',
    PROVISION_REPORT: '/scenarios/:scenarioId/provision',
    rules: {
      MAIN: '/scenarios/:scenarioId/rules/',
      COMPANY_CODES: '/scenarios/:scenarioId/rules/company-codes',
      OBLIGATIONS: '/scenarios/:scenarioId/rules/obligations',
    },
  },

  provision: {
    MAIN: '/provision',
    BATCH_PROVISIONS: '/provision/batch-provisions',
    BATCH_ADJUSTMENTS: '/provision/batch-adjustments',
  },

  balanceSheetManagement: {
    MAIN: '/balance-sheet-management',
    VIEW_TAX_ENTRIES: '/balance-sheet-management/view-tax-entries',
    ADD_TAX_ENTRY: '/balance-sheet-management/add-tax-entry',
    BATCH_TAX_ENTRIES: '/balance-sheet-management/batch-tax-entries',
    APPROVE_TAX_ENTRIES: '/balance-sheet-management/approve-tax-entries',
    VIEW_ACCOUNT_ACTIVITY: '/balance-sheet-management/view-account-activity',
    VIEW_ACCOUNT_BALANCES: '/balance-sheet-management/view-account-balances',
    VIEW_DIAGNOSTICS: '/balance-sheet-management/view-diagnostics',
    VIEW_NOTIFICATIONS: '/balance-sheet-management/view-notifications',
    RATE_CHANGE_WORKPAPER: '/balance-sheet-management/rate-change-workpaper',
    notificationsSubRoutes: {
      DIAGNOSTICS: '/administration/diagnostics/',
      UNPOSTED_GL_JOURNALS: '/balance-sheet-management/view-notifications/unposted-gl-journals',
      DECLINED_TAX_ENTRIES: '/balance-sheet-management/view-notifications/declined-tax-entries',
      TAX_ENTRIES_PENDING_APPROVAL: '/balance-sheet-management/view-notifications/tax-entries-pending-approval',
      APPROVED_TAX_ENTRIES: '/balance-sheet-management/view-notifications/approved-tax-entries',
    },
  },

  reports: {
    MAIN: '/reports',
    CONFIGURATION_SETTING: '/reports/configuration-setting',
    CUSTOM_REPORTS: '/reports/custom-reports',
    CUSTOM_REPORT: '/reports/custom-reports/:customReportId',
    EFFECTIVE_TAX_RATE: '/reports/effective-tax-rate',
    TAX_EXPENSE: '/reports/tax-expense',
    TAX_EXPENSE_WITH_EXPANDABLE_DETAILS_LIST: '/reports/new-tax-expense',
    HISTORICAL_TAX_EXPENSE: '/reports/historical-tax-expense',
    VIEW_DEFERRED_ROLLFORWARD: '/reports/view-deferred-rollforward',
    VIEW_TAX_LIFECYCLE: '/reports/view-tax-lifecycle',
    VIEW_TAX_RESERVES: '/reports/view-tax-reserves',
    BATCH_REPORTS: '/reports/batch-reports',
    MULTI_PERIOD_ANALYSIS: '/reports/multi-period-analysis',
  },

  returnToProvision: {
    MAIN: '/return-to-provision',
  },

  administration: {
    MAIN: '/administration',
    BEGINNING_BALANCES: '/administration/beginning-balances',
    BUSINESS_UNIT_SETTINGS: '/administration/business-unit-settings',
    TAX_ACCOUNTING_SETTINGS: '/administration/tax-accounting-settings',
    TAX_RATES: '/administration/tax-rates',
    TLS_ACCOUNT_SETTINGS: '/administration/tls-account-settings',
    NOL_AND_VA: '/administration/nol-and-va',
    LEGAL_ENTITY_SETTINGS: '/administration/legal-entity-settings',
    OBLIGATIONS: '/administration/obligations',
    TAX_BOOKING_ENTITIES: '/administration/tax-booking-entities',
    CORRECTING_ENTRY_LIST: '/administration/correcting-entry-list',
    GL_ACCOUNT_LIST: '/administration/gl-account-list',
    ACCOUNT_MAP: '/administration/account-map',
    SL_ACCOUNTS_PAGE: '/administration/sl-account-page',
    COMPANY_CODES: '/administration/company-codes',
    CURRENCY_CONVERSION_RATES: '/administration/currency-conversion-rates',
    GL_JOURNALS: '/administration/gl-journals',
    BOOK_TO_TAX_DIFFERENCE: '/administration/book-to-tax-difference',
    CUSTOM_REPORTS_MANAGEMENT: '/administration/custom-reports-management',
    CATEGORIES_AND_TAGS: '/administration/categories-and-tags-page',
    CONNECTION_SETTINGS: '/administration/connection-settings',
    CLIENT: '/administration/client',
    ADMIN_TAX_ENTRY: '/administration/admin-tax-entry-settings',
    CHART_OF_ACCOUNTS: '/administration/chart-of-accounts',
    CUSTOM_GROUPS: '/administration/custom-groups',
    USER_SETTINGS: '/administration/users-and-privileges',
    USER_EXPIRATION: '/administration/user-expiration',
    APPLICATION_SETTINGS: '/administration/application-settings',
    E2E_HEALTHCHECK: '/administration/e2e-healthcheck',
    ADMIN_IMPORT: '/administration/admin-import',
    TRIAL_BALANCE_THRESHOLD: '/administration/trial-balance-threshold',
    DIAGNOSTICS: '/administration/diagnostics',
    DATABASE_LOGS: '/administration/db-logs',
    COMMUNICATIONS_MANAGEMENT: '/administration/communications-management',
    ROLES: '/administration/roles',
    CLIENT_ADMINISTRATION: '/administration/client-administration',
  },
} as const;

type FlattenRoutesParams = { [key: string]: string | FlattenRoutesParams };
const flattenRoutes = (obj: FlattenRoutesParams): string[] => Object.values(obj).reduce((acc, value) => {
  if (typeof value === 'string') {
    return acc.concat(value);
  }
  return acc.concat(flattenRoutes(value));
}, [] as string[]);

export const allRoutesArray = flattenRoutes(Routes);
export default Routes;
